import React, { useEffect, useRef } from 'react';
import styles from './styles.module.css';
import ImageComponent from '../../ImageComponent';
import clsx from 'clsx';
import { getEventProcessor } from '../../../pages/GamePlay/eventProcessor';
import { getHeight, getWidth } from '../../../utils/relativeSizes';

interface IKukariBounceAnimationProps {
  kukariImage: string;
  tokenIndex: number;
  onMoveTokenClick: (tokenIndex: number) => void;
  testID?: string;
}

const KukariBounceAnimation: React.FC<IKukariBounceAnimationProps> = ({
  kukariImage,
  tokenIndex,
  onMoveTokenClick,
  testID,
}) => {

  return (
    <div
      className={clsx(styles.kukariWrapper)}
      data-testid={testID}
      onClick={()=> getEventProcessor()?.handleMoveTokenClick(tokenIndex)}
    >
      <ImageComponent 
        src={kukariImage} 
        alt="kukari" 
        className={styles.kukariImage} 
        style={{
          width: getWidth(19),
          height: getHeight(32)
        }}
      />
    </div>
  );
};

export default KukariBounceAnimation;